<span class="badge badge-pill {{ type ? styles[type] : '' }}"> {{ type ? (('transactionType.'+type) | translate) : ''}}</span>
